module.exports = __webpack_public_path__ + "img/2.988b0299.jpg";